import styled from 'styled-components';
import { Alert, DialogTitle } from '@mui/material';

const StyledAlert = styled(Alert)`
  font-weight: bold;
  border-radius: 0px !important;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;

  & .MuiAlert-message {
    font-weight: bold;
  }
`;

const StyledDialogTitle = styled(DialogTitle)`
  text-align: center;
`;

const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export {
  StyledAlert,
  StyledDialogTitle,
  AlertContainer,
};
